export default "__VITE_PUBLIC_ASSET__444ebf06__"